import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from './TopAppBar';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FindDoctor from './FindDoctor';
import SelectDate from './SelectDate';
import PersonalInfo from './PersonalInfo';
import Confirmation from './Confirmation';
import FooterBar from './FooterBar';


const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3,
    },
  },
  stepper: {
    padding: `${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 5}px`,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
});

const steps = ['Find Doctors', 'Select Date', 'Personal Info', 'Confirmation'];


class Appointment extends React.Component {
  state = {
    activeStep: 0,
    city: '',
    exp: '',
    fromFee: '',
    toFee: '',
    doctor:'',
    appointmentDate: new Date(),
    session:'',
    patientName: '',
    mobileNo: ''
  };

  handleNext = () => {
    this.setState(state => ({
      activeStep: state.activeStep + 1,
    }));
  };

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  handleStep = step => () =>{
    this.setState({
      activeStep: step,
    });
  }

  handleChange = input => event => {
    switch (input) {
      case 'doctor':
      this.setState({ [input]: event.currentTarget.value });
      break;
      case 'appointmentDate':
      this.setState({ [input]: event} );
      break;
      default:
      this.setState({ [input]: event.target.value} );
    }
  };

 getStepContent(step, values) {
  switch (step) {
    case 0:
      return <FindDoctor values={values} handleChange={this.handleChange} />;
    case 1:
      return <SelectDate values={values} handleChange={this.handleChange} />;
    case 2:
      return <PersonalInfo values={values} handleChange={this.handleChange} />;
    case 3:
      return <Confirmation values={values} handleChange={this.handleChange} />;
    default:
      throw new Error('Unknown step');
  }
}

  render() {
    const { classes } = this.props;
    const { activeStep, city, exp, fromFee, toFee, doctor, appointmentDate, patientName, mobileNo, session } = this.state;
    const  values  = { activeStep , doctor, appointmentDate, patientName, mobileNo, city, exp, fromFee, toFee, session  };
    console.log(values);
    return (
      <React.Fragment>
        <CssBaseline />
        <AppBar></AppBar>
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
            Book Your Appointment Now
            </Typography>
            <Stepper activeStep={activeStep} className={classes.stepper}>
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepLabel onClick={this.handleStep(index)}>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <React.Fragment>
              {activeStep === steps.length ? (
                <React.Fragment>
                  <Typography variant="h5" gutterBottom>
                    Your appointment got confirmed.
                  </Typography>
                  {/* <Typography variant="subtitle1">
                    Your order number is #2001539. We have emailed your order confirmation, and will
                    send you an update when your order has shipped.
                  </Typography> */}
                </React.Fragment>
              ) : (
                  <React.Fragment>
                    {this.getStepContent(activeStep, values)}
                    <div className={classes.buttons}>
                      {activeStep !== 0 && (
                        <Button onClick={this.handleBack} className={classes.button}>
                          Back
                      </Button>
                      )}
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleNext}
                        className={classes.button}
                      >
                        {activeStep === steps.length - 1 ? 'Fix Appointment' : 'Next'}
                      </Button>
                    </div>
                  </React.Fragment>
                )}
            </React.Fragment>
          </Paper>
        </main>
        <FooterBar></FooterBar>
      </React.Fragment>
    );
  }
}

Appointment.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Appointment);